import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import IconButton from "../input/IconButton";
import Icon from "../presentation/Icon";

import { getOption } from '../../lib/api/getOptions';
import { cloneDeep } from 'lodash';

import getList from '../../lib/api/getList';

import BasicCrudScreenTypeLayout from "../screenTypes/layout/BasicCrudScreenTypeLayout";
import BasicCrudScreenHeaderLayout from "../screenTypes/layout/BasicCrudScreenHeaderLayout";
import BasicCrudScreenContentLayout from "../screenTypes/layout/BasicCrudScreenContentLayout";
import BasicCrudScreenFooterLayout from "../screenTypes/layout/BasicCrudScreenFooterLayout";
import BasicCrudActionsLayout from "../screenTypes/layout/BasicCrudActionsLayout";
import ToolbarFlexSpacer from "../layout/ToolbarFlexSpacer";

import EguSalesStatusSummaryPage from "./EguSalesStatusSummaryPage";

function EguSalesMonitoring ( props ) {
    
    const { t } = useTranslation();
    const { handle, onComplete } = props;

    let currentTime = new Date ();

    const [time, setTime] = useState ( `${currentTime.getFullYear()}-${currentTime.getMonth() + 1}-${currentTime.getDate()} ${currentTime.getHours()}:${currentTime.getMinutes()}` );
    const [page, setPage] = useState ("");
    const [salesStatus, setSalesStatus] = useState ();

    const getData = async ( start, length, interval ) => {

        try {
    
            let result = await getList ( `EguVwSalesStatusSummary?$start=${start}&$length=${length}` );

            let salesStatus = cloneDeep ( result );
    
            salesStatus.start = start;
            salesStatus.length = length;
            salesStatus.interval = interval;
    
            if ( salesStatus?.data?.length > 0 ) {
                        
                while ( salesStatus?.data?.length < length ) {
    
                    salesStatus.data.push ( {
                        orderBuyerId: "-",
                        companyName: "",
                        materialName: "",
                        unitCost: "",
                        qty: "",
                        orderBuyerDate: "",
                        dueDate: "",
                        process1: "",
                        process2: "",
                        process3: "",
                        process4: "",
                        qtyInput: "",
                        shipmentOrderDate: "",
                        shipmentQty: "",
                        shipDate: "",
                        shipQty: ""
                    } );
    
                }
                
                let page = Math.floor ( start / length ) + 1 + " / " +  Math.ceil ( result.total / length );
    
                let currentTime = new Date ();
    
                setTime ( `${currentTime.getFullYear()}-${currentTime.getMonth() + 1}-${currentTime.getDate()} ${currentTime.getHours()}:${currentTime.getMinutes()}` );
                setPage ( page );
                setSalesStatus ( salesStatus );
    
            } else {
    
                if ( onComplete ) {
    
                    onComplete ();

                } else if ( start > 0 ) {

                    // 단독 화면 — 끝 쪽을 지나면 첫 쪽부터 다시 읽어 자동 갱신을 이어 간다
                    await getData ( 0, length, interval );

                }
    
            }

        } catch ( reason ) {

            console.error ( reason );
            setTimeout ( () => getData ( start, length, interval ), interval * 1000 );

        }

    }

    const nextPage = ( start, length, interval ) => {

        let currentTime = new Date ();

        setTime ( `${currentTime.getFullYear()}-${currentTime.getMonth() + 1}-${currentTime.getDate()} ${currentTime.getHours()}:${currentTime.getMinutes()}` );

        ( async () => {

            await getData ( start, length, interval );

        } ) ();

    };

    useEffect ( () => {

        ( async () => {

            let length = await getOption ( "dashboard", "salesMonitoringPageLength" );
            let interval = await getOption ( "dashboard", "salesMonitoringDisplayInterval" );

            length = length !== undefined ? parseInt(length) : 20;
            interval = interval !== undefined ? parseInt(interval) : 5;

            let start = 0;

            await getData ( start, length, interval );
    
        } ) ();

        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );


    return (

        <BasicCrudScreenTypeLayout>

            <BasicCrudScreenHeaderLayout className="basicCrudScreenHeaderLayout">

                    <BasicCrudActionsLayout className="basicCrudScreenActionsLayout">

                        <span
                            color="inherit"
                            align="center"
                            style={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    marginLeft: "8px",
                                    marginTop: "0px",
                                    marginBottom: "8px"
                            }}
                        >
                            { t ("term.salesStatus") }
                        </span>
                        
                        <ToolbarFlexSpacer xs />

                        {
                            handle
                            ?
                            (
                                <span
                                    style={{
                                        marginRight: "8px"
                                    }}                                
                                >

                                    <span
                                        color="inherit"
                                        align="center"
                                        style={{
                                            fontSize: "16px",
                                            marginLeft: "8px",
                                            marginTop: "0px",
                                            marginBottom: "8px",
                                            marginRight: "8px"
                                        }}
                                    >
                                        {time}
                                    </span>

                                    {
                                        handle.active
                                        ?
                                        <IconButton size="small" onClick={handle.exit} style={{marginBottom: "4px"}}>
                                            <Icon>fullscreen_exit</Icon>
                                        </IconButton>
                                        :
                                        <IconButton size="small" onClick={handle.enter} style={{marginBottom: "4px"}}>
                                            <Icon>fullscreen</Icon>
                                        </IconButton>
                                    }

                                </span>

                            )
                            :
                            <span
                                color="inherit"
                                align="center"
                                style={{
                                    fontSize: "16px",
                                    marginLeft: "8px",
                                    marginTop: "0px",
                                    marginBottom: "8px",
                                    marginRight: "8px"
                                }}
                            >
                                {time}
                            </span>

                        }

                    </BasicCrudActionsLayout>
                    
            </BasicCrudScreenHeaderLayout>

             <BasicCrudScreenContentLayout className="basicCrudScreenContentLayout">
 
                <>
                    <EguSalesStatusSummaryPage salesStatus={salesStatus} onComplete={nextPage} />

                </>

            </BasicCrudScreenContentLayout>
            <BasicCrudScreenFooterLayout className="basicCrudScreenFooterLayout">
                        
                <ToolbarFlexSpacer xs />

                <span
                    color="inherit"
                    align="center"
                    style={{
                            fontSize: "16px",
                            marginLeft: "8px",
                            marginTop: "8px",
                            marginRight: "8px"
                    }}
                >
                    {page}
                </span>

            </BasicCrudScreenFooterLayout>

        </BasicCrudScreenTypeLayout>



    )
}

export default EguSalesMonitoring;
